<template>
   
      <div class="inbanner bg-cover">
        <el-image src="images/lb/yfcx.jpg"></el-image>
      <!-- <div class="inwrap l-m-c">
        <h2 class="fnt_40 wow fadeInUp animated animated" style="visibility: visible; animation-name: fadeInUp;">科技研发</h2>
        <h3 class="fnt_18 wow fadeInUp animated animated" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">Product center</h3>
      </div> -->
    </div>
    <pipelineView></pipelineView>
    <div class="clearfix" ></div>
    <InnovationIndex></InnovationIndex>
    <div class="clearfix" ></div>
    <projectView></projectView>
    <div class="clearfix" ></div>
    <ProjectMedicine></ProjectMedicine>
    <div class="clearfix" ></div>
    <br>
    <nationalHonor></nationalHonor>
    <div class="clearfix" ></div>
   

</template>

<script>
import 'animate.css'
import * as  http from '@/request/http'
import { useRouter} from 'vue-router';
import { useStore } from 'vuex';
 
import InnovationIndex from './InnovationIndex.vue'
 
import projectView from './projectView.vue';
import pipelineView from  './pipelineView.vue'
import nationalHonor from  './nationalHonor.vue'
import ProjectMedicine from  './ProjectMedicine.vue'

export default {
   components: {
    //   Pagination
    pipelineView,
    InnovationIndex,
    projectView,
    nationalHonor,
    ProjectMedicine
    },
   data(){
    return {    
      currentPage: 1,
      pageSize: 10,
      totalItems: 1,  
      projects:[],
      projectsdata:{}
    }
   },
   methods: {
    handlePageChanged(newPage) {
       let  param = {
          newTitle: '',
          currentPage: this.currentPage,
          type:''
       }
        this.currentPage = newPage;
        http.projects.projectslist(param).then(res=>{
           console.log(res.data) 
           this.projectsdata = res.data,
           this.projects=res.data.rows
           this.currentPage =newPage;
           this.pageSize=10;
           this.totalItems=res.data.total
        })
      },
   },
   created(){
    this.handlePageChanged(1)
 
   },
   props: {
    user: Object
  },
  setup() {
    const router = useRouter();
    // 使用全局$store
    const store = useStore();
 
    function gotoDetail(item) {
      const state= item
      store.state.productStore.currentProduct=item
      router.push({ name: 'productDetail',state});
    }
    return {
      gotoDetail
    };
  }
}
</script>

<style>
.col-sm-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
    margin-top: 120px;
}
.padding-big {
  padding: 20px 0;
}

</style>